import React, { useCallback, useContext } from 'react'
import { Step4Styles } from './Style'
import { PerformAssessmentContext } from './PerformAssessmentContext'
import { Words } from 'pages'
import { queryClient as qc } from 'keys'
import { getQuestionsFetch, getWordDefsFetch } from 'store/middlewares/words.crud'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

const Step4 = () => {
    const { goToNextAssessmentInQueue, blobURL, isPreviewMode, setFinishFlag, questionValues, setQuestionValues, stopRecord, setAssessments, assessments, setBlobURL, setAudioURL, audioChunks, setAudioChunks, wordDefs, assessmentDef, assessment, currentStep, setCurrentStep, saveAssessment } = useContext(PerformAssessmentContext)
    const params = useParams()
    const assessmentID = params.assessmentID

    const wordDefsData = useQuery({
        queryKey: [qc.wordDefs, assessmentID, assessment?.reading_assessment_def_id],
        enabled: !!assessment?.reading_assessment_def_id,
        queryFn: async ({ signal }) => {
            const { data } = await getWordDefsFetch({ signal, id: assessment?.reading_assessment_def_id })
            return data.word_defs
        }
    })

    const questions = useQuery({
        queryKey: [qc.questions, assessmentID, assessment?.reading_assessment_def_id || 0],
        queryFn: async () => {
            let { data } = await getQuestionsFetch({ id: assessment?.reading_assessment_def_id })
            setQuestionValues(new Array(data?.length).fill(null))
            return data
        },
    })

    const goNextStep = useCallback(async () => {
        // if (!saveAssessment) return

        try {
            await Promise.resolve(saveAssessment())
        } catch (e) {
            console.log(e)
        }

        // if (isPreviewMode) {
        setCurrentStep(5)
        // } else {
        goToNextAssessmentInQueue()
        // }
    }, [blobURL, audioChunks, questionValues, assessment, isPreviewMode, saveAssessment])

    return (
        <Step4Styles>
            {wordDefsData?.data &&
                <Words
                    questions={questions.data}
                    questionValues={questionValues}
                    setQuestionValues={setQuestionValues}
                    print={true}
                    type={assessmentDef?.visible_type}
                    name={assessmentDef?.name}
                    words={wordDefsData?.data}
                    student={true}
                    finishPerfom={goNextStep}
                />}
        </Step4Styles>
    )
}

export default Step4